import { environment } from "../environments/environment.staging";

let baseUrl = environment.baseUrl;
export class URLConfig {
  //Auth Module
  public static signup = baseUrl + "auth/register";
  public static login = baseUrl + "auth/login";
  public static forgotPassword = baseUrl + "auth/forgot-password";
  public static resetPassword = baseUrl + "auth/reset-password";
  public static verifyEmail = baseUrl + "auth/verify-email";
  public static sendVerificationEmail = baseUrl + "auth/send-verification-email";
  public static socialLogin = baseUrl + "auth/social-login";
  public static refreshToken = baseUrl + "Auth/refresh-token";
  public static changepassword = baseUrl + "auth/change-password";
  public static verifyId = baseUrl + "Auth/verify-id";
  // public static loggedInUserDetails = baseUrl + "user/get-user?"
  //Home Module
  public static home = baseUrl + "home/home-data";
  public static allPicked = baseUrl + "Home/all-picked";
  public static allRecents = baseUrl + "Home/all-recents";
  public static spotlightListing = baseUrl + "Home/spotlight-listing";
  public static allAuctions = baseUrl + "Home/all-auctions";
  public static homeBrandItems = baseUrl + "Home/brand-items";
  public static search = baseUrl + "Home/search";
  public static brandItems = baseUrl + "brands/brand-search";
  public static brands = baseUrl + "brands/all-brands";
  public static categoryItems = baseUrl + "home/category-items";
  public static subCategoryItems = baseUrl + "home/sub-category-items";
  public static conditionalItems = baseUrl + "home/condition-search";
  public static recentItems = baseUrl + "home/all-recents";
  // items get endpoint
  public static itemDetail = baseUrl + "Items/item-detail";
  public static relatedItems = baseUrl + "Items/related-items";
  public static likeItem = baseUrl + "Items/like-item";
  public static itemOwnerDetail = baseUrl + "Items/item-detail-owner";
  public static editDetail = baseUrl + "Items/edit-item";
  //Shops
  public static shopDetail = baseUrl + "shop/shop-public-view";
  public static myShopDetail = baseUrl + "Shop/shop-detail";
  public static updateShopDetails = baseUrl + "Shop/update-shop-details";
  public static shops = baseUrl + "home/all-shops";
  public static shopItem = baseUrl + "shop/shop-items";
  public static shopStatus = baseUrl + "shop/create-shop";
  //my Shop 
  public static myshopsCoverPic = baseUrl + "user/update-cover-pic";
  public static myshopsProfilePic = baseUrl + "user/update-profile-pic";
  public static myshopsDesc = baseUrl + "user/update-description";
  //ziina
  public static connectZiina = baseUrl + "shop/ziina-client-id";
  public static codeZiina = baseUrl + "shop/ziina-token";
  //favourites 
  public static addFavourite = baseUrl + "Favourite/add-favourite";
  public static getFavourite = baseUrl + "User/likes";
  public static delFavourite = baseUrl + "Favourite/delete-favourite";
  //Item-AddShop
  public static getItem = baseUrl + "Items/item-prerequisite";
  public static getSubCategories = baseUrl + "Items/subcategories";
  public static getSubSubCategories = baseUrl + "Items/sub-subcategories";
  public static addItem = baseUrl + "Items/add-item";
  public static addAuctionItem = baseUrl + "Auctions/add-auction-item";
  public static auctionUpdateItem = baseUrl + "Auctions/update-auction-item";
  public static likeAuctionItem = baseUrl + "Auctions/like-auction-item";
  public static auctionItemDetail = baseUrl + "Auctions/auction-item-detail";
  public static auctionRelatedItems = baseUrl + "Auctions/auction-related-items";
  public static auctionLatestBid = baseUrl + "Auctions/latest-bid";
  public static auctionPlaceBid = baseUrl + "Auctions/place-bid";
  public static auctionDeleteItem = baseUrl + "Auctions/delete-auction-item";
  public static auctionHideItem = baseUrl + "Auctions/visible";
  public static auctionSoldItem = baseUrl + "Auctions/sold";
  public static auctionBuyItNow = baseUrl + "Auctions/buy-it-now";
  public static auctionEndAuction = baseUrl + "Auctions/end-auction";
  public static auctionExtendAuction = baseUrl + "Auctions/extend-auction";
  public static auctionBidHistory = baseUrl + "Auctions/bid-history/";
  public static editItem = baseUrl + "Items/item-update";
  public static uplaodImage = baseUrl + "Items/item-image-upload";
  public static deleteImage = baseUrl + "Items/item-image-delete";
  //Notification
  public static getNotification = baseUrl + "User/notifications";
  public static delNotification = baseUrl + "Notification/delete-notification";
  public static readNotification = baseUrl + "User/mark-as-seen";
  //cart
  public static addCart = baseUrl + "Cart/add-cart";
  public static getCart = baseUrl + "cart/cart";
  public static getCartUi = baseUrl + "Cart/cart";
  public static delCart = baseUrl + "cart/delete-cart-item";
  public static removeCart = baseUrl + "Cart/remove-cart";
  public static updateCartUi = baseUrl + "Cart/update-cart";
  public static updateQtyCart = baseUrl + "cart/update-quantity";
  public static checkCart = baseUrl + "cart/check-quantity";
  public static checkOutCart = baseUrl + "cart/checkout";
  public static createOrder = baseUrl + "cart/create-order";
  public static placeOrder = baseUrl + "Cart/place-order";
  public static userShipping = baseUrl + "user/shipping";
  public static updatecheckOutCart = baseUrl + "cart/update-checkout";
  public static like = baseUrl + "shop/like-shop";
  public static likeShop = baseUrl + "Shop/like-shop";
  public static shopReview = baseUrl + "Shop/shop-review";
  public static shopReviews = baseUrl + "Shop/shop-reviews";
  public static sellerBankDetails = baseUrl + "Seller/bankdetails";
  public static sellerWithdraw = baseUrl + "Seller/withdraw";
  public static shopOrders = baseUrl + "Shop/shop-orders";
  public static shopPurchases = baseUrl + "Shop/purchases";
  public static shopOrderDetail = baseUrl + "Shop/shop-order-detail";
  public static shopUpdateOrderStatus = baseUrl + "Shop/update-order-status";
  public static itemReview = baseUrl + "Items/item-review";
  public static itemReviews = baseUrl + "Items/item-reviews";
  //promo Code 
  public static getPromoCode = baseUrl + "promo/apply-promo";
  public static postPromoCode = baseUrl + "promo/add-promo";
  public static getAllPromoCode = baseUrl + "promo/all-promos";
  public static getPromoCodeStatus = baseUrl + "promo/promo-status";
  public static delPromoCode = baseUrl + "promo/delete-promo";
  public static updateCartPromoCode = baseUrl + "cart/update-cart-item";
  //payment
  public static getPayment = baseUrl + "orders/new-order";
  //myOrder
  public static myOrder = baseUrl + "user/my-orders";
  public static mypurchase = baseUrl + "user/my-purchases";
  public static files = baseUrl + "chat/download-files";
  public static orderStatus = baseUrl + "orders/update-order-status";
  //User Update
  public static updateNotification = baseUrl + "user/update-notification";
  public static updateContact = baseUrl + "user/update-contact";
  public static updateProfile = baseUrl + "user/update-profile";
  public static updateEmail = baseUrl + "user/update-email-preference";
  public static updateHoliday = baseUrl + "user/update-holiday";
  public static updateUser = baseUrl + "user/update-user";
  public static profile = baseUrl + "Profile/profile";
  //review 
  public static clientReview = baseUrl + "review/all-reviews";
  public static clientPostReview = baseUrl + "review/submit-review";
  //bank
  public static getBankDetailByUser = baseUrl + "user/get-bank-details";
  public static AddBank = baseUrl + "user/submit-bank-details";
  // info
  public static saveInfo = baseUrl + "info/add-Info-query";
  //chat
  public static connectionBuild = baseUrl + "chatHub";
  public static chatImage = baseUrl + "chat/upload-image";
  //Dashboard 
  public static dashboardData = baseUrl + "Dashborad/get-dashboard-data";
  public static getDashboardGraphData = baseUrl + "Dashborad/get-graphdata-onload";
  public static getDashboardGraphByYearData = baseUrl + "Dashborad/get-graphdata-by-year";
  public static getDashboardGraphByYearRangeData = baseUrl + "Dashborad/get-graphdata-by-year-range";
  //Sold Item
  public static soldItem = baseUrl + "Items/sold";
  //Delete Item
  public static deleteItem = baseUrl + "Items/delete-item";
  //Hide Item
  public static hideItem = baseUrl + "Items/visible";
  //paymentapi 
  public static startpaymentApi = baseUrl + "cart/start-payment";
  public static paymentStatusApi = baseUrl + "cart/payment-status";
  public static paymentStatusErrorApi = baseUrl + "cart/payment-error";
  // storeRequest
  public static storeRequest = baseUrl + "Auth/store-request";
  //Boost
  public static getBoost = baseUrl + "Items/item-packages";
  public static boostPayment = baseUrl + "Items/spot-light-payment";
  public static verifySpotLight = baseUrl + "Items/verfiy-spotlight";
  public static image = baseUrl + "Media/media";

}
